import React from 'react'
import { useNavigate } from 'react-router-dom'
import styled from 'styled-components'
import WidgetCard from './WidgetCard'

const List = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 12px;
`

const Item = styled.li`
  cursor: pointer;
`

const Title = styled.div`
  font-weight: 600;
  font-size: 14px;
  color: ${(p) => p.theme?.color?.ink || '#1F2937'};
  margin-bottom: 6px;
`

const Sub = styled.div`
  font-size: 12px;
  color: ${(p) => p.theme?.color?.inkMuted || '#6B7280'};
  margin-top: 6px;
`

const Bar = styled.div`
  height: 6px;
  border-radius: 999px;
  background: ${(p) => p.theme?.color?.bgSubtle || '#F4F0E9'};
  position: relative;
  overflow: hidden;
`

const BarFill = styled.div`
  position: absolute;
  inset: 0;
  width: ${(p) => p.$pct}%;
  background: ${(p) => p.theme?.color?.accent || '#6B9080'};
  border-radius: 999px;
  transition: width 200ms ease-out;
`

export default function GoalNudgeCard({ data }) {
  const navigate = useNavigate()
  if (!data || data.length === 0) return null
  return (
    <WidgetCard title="Goals">
      <List>
        {data.map((g) => (
          <Item key={g.goalId} onClick={() => navigate('/patient-home/care/goals')}>
            <Title>{g.title}</Title>
            <Bar>
              <BarFill $pct={Math.max(0, Math.min(100, g.progressPct || 0))} />
            </Bar>
            <Sub>{g.progressPct ?? 0}% · {g.microCopy || ''}</Sub>
          </Item>
        ))}
      </List>
    </WidgetCard>
  )
}
